import { Pipe, PipeTransform } from '@angular/core';
import { OrderReturnRejectionReason } from '../../models/order-return/order-return-rejection-reason';

@Pipe({
  standalone: false,
  name: 'rejectionReason',
})
export class OrderReturnRejectionPipe implements PipeTransform {
  transform(justification?: string | OrderReturnRejectionReason) {
    switch (justification) {
      case OrderReturnRejectionReason.PRODUCT_USED:
        return 'Produto com sinais de uso';
      case OrderReturnRejectionReason.NO_OR_DAMAGED_PACKAGING:
        return 'Sem embalagem original ou embalagem danificada';
      case OrderReturnRejectionReason.RETURN_PERIOD_EXPIRED:
        return 'Prazo para devolução expirado';
      case OrderReturnRejectionReason.NO_IDENTIFICATION_OR_WARRANTY_CERTIFICATE:
        return 'Produto sem identificação ou certificado de garantia';
      case OrderReturnRejectionReason.INCOMPLETE_PRODUCT:
        return 'Produto incompleto';
      case OrderReturnRejectionReason.WRONG_PRODUCT_RETURNED:
        return 'Produto errado devolvido';
      case OrderReturnRejectionReason.ERROR_IMAGE:
        return 'Falta de Foto / Foto desfocada / Imagem inconclusiva';
      default:
        return justification ? justification : '-';
    }
  }
}
//* Deve ser atualizado o De/Para do e-mail de rejeição caso seja adicionado um novo motivo de recusa
